const youtubeHosts = new Set([
  'youtube.com',
  'www.youtube.com',
  'youtube-nocookie.com',
  'www.youtube-nocookie.com'
]);
export const youtubePermissions =
  'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';

export function getYoutubeEmbedUrl(source = '') {
  try {
    const url = new URL(String(source).trim().replace(/^\/\//, 'https://'));
    if (
      !['http:', 'https:'].includes(url.protocol) ||
      url.username ||
      url.password ||
      url.port ||
      !youtubeHosts.has(url.hostname) ||
      !/^\/embed(?:\/[a-z0-9_-]+)?\/?$/i.test(url.pathname)
    )
      return '';
    url.protocol = 'https:';
    return url.href;
  } catch {
    return '';
  }
}

// PDF preview o'lchamlari: admin (TinyMCE), backend va frontendda bir xil.
export const PDF_PREVIEW_LIMITS = Object.freeze({
  width: [320, 1920],
  height: [150, 1200],
  defaultHeight: 600
});

const ABSOLUTE_PDF_PATTERN = /^https?:\/\/[^/?#\s]+\/uploads\/[a-f0-9-]+\.pdf(?:[?#][^\s"'<>]*)?$/i;
const RELATIVE_UPLOAD_PATTERN = /^(?:\.{1,2}\/)*\/?uploads\/([^?#\s"'<>]+)((?:[?#][^\s"'<>]*)?)$/i;
const DATA_PDF_PATTERN = /^data:application\/pdf;base64,[a-z0-9+/=\s]+$/i;

// "../uploads/x.png", "/uploads/x.pdf" kabi nisbiy yuklangan fayl manzilini API domenidagi
// to'liq manzilga aylantiradi. TinyMCE URL larni nisbiy qilib saqlagan kontent uchun kerak:
// aks holda /news/page/5 sahifasida "../uploads" noto'g'ri papkaga ketadi.
export function resolveUploadUrl(source = '', baseUrl = '') {
  const value = String(source || '').trim();
  const match = RELATIVE_UPLOAD_PATTERN.exec(value);

  if (!match || !baseUrl) {
    return value;
  }

  return `${String(baseUrl).replace(/\/$/, '')}/uploads/${match[1]}${match[2] || ''}`;
}

export function getPdfPreviewUrl(source = '', baseUrl = '') {
  const value = String(source || '').trim();

  if (DATA_PDF_PATTERN.test(value)) {
    return value;
  }

  if (ABSOLUTE_PDF_PATTERN.test(value)) {
    const url = new URL(value);

    if (
      url.protocol === 'https:' &&
      ['ukiu.uz', 'www.ukiu.uz'].includes(url.hostname) &&
      !url.port
    ) {
      url.hostname = 'new.ukiu.uz';
      return url.href;
    }

    return value;
  }

  const resolved = resolveUploadUrl(value, baseUrl);
  return resolved !== value && /\/uploads\/[a-f0-9-]+\.pdf(?:[?#].*)?$/i.test(resolved) ? resolved : '';
}

export function getContentEmbedType(source = '', className = '', baseUrl = 'https://invalid.local') {
  if (getYoutubeEmbedUrl(source)) return 'youtube';
  if (
    String(className).split(/\s+/).includes('content-pdf-preview__frame') &&
    getPdfPreviewUrl(source, baseUrl)
  )
    return 'pdf';
  return '';
}

export function normalizeContentIframe(element, baseUrl = '') {
  const type = getContentEmbedType(element.getAttribute('src') || '', element.className, baseUrl || 'https://invalid.local');
  if (!type) return '';
  element.removeAttribute('sandbox');
  if (type === 'pdf') {
    element.setAttribute('src', getPdfPreviewUrl(element.getAttribute('src'), baseUrl));
    element.setAttribute('loading', 'lazy');
  }
  if (type === 'youtube') {
    element.src = getYoutubeEmbedUrl(element.getAttribute('src'));
    element.classList.add('content-video-frame');
    element.setAttribute('allow', youtubePermissions);
    element.setAttribute('allowfullscreen', '');
    element.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    element.setAttribute('loading', 'lazy');
    if (!element.title) element.title = 'YouTube video';
    const width = Number(element.getAttribute('width'));
    const height = Number(element.getAttribute('height'));
    if (!element.style.width) element.style.width = width > 0 && width <= 4096 ? `${width}px` : '100%';
    element.style.height = 'auto';
    element.style.aspectRatio =
      width > 0 && height > 0 && width <= 4096 && height <= 4096 ? `${width} / ${height}` : '16 / 9';
  }
  return type;
}

export function sanitizePdfPreviewStyle(value = '', property) {
  const match = new RegExp(`^\\s*${property}\\s*:\\s*(\\d{1,4})px\\s*;?\\s*$`, 'i').exec(String(value || ''));
  if (!match) return '';
  const dimension = Number(match[1]);
  const limits = PDF_PREVIEW_LIMITS[property === 'width' ? 'width' : 'height'];
  return dimension >= limits[0] && dimension <= limits[1] ? `${property}: ${dimension}px` : '';
}
